import { FlexColumn, Tooltip } from '@ubeya/shared-web/components';
import styled from 'styled-components';
import moment from 'moment';
import { ago } from '@ubeya/shared/utils/time';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled(FlexColumn)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5px;
`;

const Image = styled.img.attrs(() => ({ className: 'client-signoff-image' }))`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ClientSignoffRenderer = ({ rowData: { clientApproved } }) => {
  const { dateFormat, timeFormat } = useContext(ConfigContext);
  const { t } = useContext(ConfigContext);

  if (!clientApproved || !clientApproved?.signature) {
    return <></>;
  }

  const { createdAt } = clientApproved;

  const timeAgo = createdAt
    ? `${ago(createdAt, t)} (${moment(createdAt).format(dateFormat)} ${moment(createdAt).format(timeFormat)})`
    : '';

  const tooltip = `${t('clientApprovedTimesheet')}, ${timeAgo}`;

  return (
    <Wrapper>
      <Tooltip body={tooltip}>
        <Image src={clientApproved?.signature} />
      </Tooltip>
    </Wrapper>
  );
};

export default ClientSignoffRenderer;
